export default __webpack_public_path__ + "static/media/mailgun.61ccf27e.svg";